import Table from 'react-bootstrap/Table';
import PreLoader from '../../Loader/PreLoader';
import { useEffect, useState } from 'react';
import NoDataFoundLayout from '../../layouts/NoDataFoundLayout';
import Swal from 'sweetalert2';
import api from '../../utils/axiosConfig';

const SemesterGrade = () => {
  const [semesterResult, setSemesterResult] = useState([]);
  const [loading, setLoading] = useState(true);

  
    useEffect(() => {
    const fetchSemesterResult = async () => {
      const studentUid = sessionStorage.getItem('student_uid');

      if (!studentUid) {
         Swal.fire({
            title: 'Error',
            text: 'Student UID not found in session storage. Please login again.',
            icon: 'error',
         });
        setLoading(false);
        return;
      }

      try {
        const response = await api.get(`/view-semester-result/${studentUid}`);
        setSemesterResult(response.data);
      } catch (error) {
        console.error('Error fetching course data:', error);
        setSemesterResult([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSemesterResult();
  }, []);

  if (loading) {
    return <PreLoader />;
  }

  if (!semesterResult || semesterResult.length === 0) {
    return <NoDataFoundLayout errorCaption="No result found" />;
  }

  console.log(semesterResult);

  return (
    <div className="container mt-4">
      <h4 className="card-title text-center fw-semibold mb-3">
        <span className="px-4 py-2 rounded-pill bg-white border shadow-sm text-dark small">
          Semester Result
        </span>
      </h4>

      <div class="formula">
    <strong>GPA</strong> =
    <div class="fraction">
        <span class="numerator">
            <span class="sigma">&Sigma;</span>
            (Earned Grade Point &times; Individual Course Credit Hours)
        </span>
        <span class="denominator">
            Total Registered Credit Hours
        </span>
    </div>
</div>

      <Table bordered hover responsive className="text-center align-middle">
        <thead className="table-light">
          <tr>
            <th>Semester</th>
            <th>Course Code</th>
            <th>Course Title</th>
            <th>Enroll Type</th>
            <th>Enrolled Credits</th>
            <th>Earned Grade Point</th>
            <th>Letter Grade</th>
            <th title='Term GPA'>TGPA</th>
            <th title='Cumulative gpa'>CGPA</th>
            <th>Enrolled Credits</th>
            <th>Earned Credits</th>
          </tr>
        </thead>
        <tbody>
        {semesterResult.map((sem) =>
          sem.courses.map((c, i) => (
            <tr key={sem.semester + i}>
              {i === 0 && (
                <td rowSpan={sem.rowspan}>{sem.semester}</td>
              )}
              <td>{c.course_code}</td>
              <td>{c.course_title}</td>
              <td>{c.enroll_type}</td>
              <td>{c.credits}</td>
              <td title={`Marks ${c.total_marks}`}>{c.grade_point}</td>
              <td>{c.letter_grade}</td>

              {i === 0 && (
                <>
                  <td rowSpan={sem.rowspan}>{sem.tgpa}</td>
                  <td rowSpan={sem.rowspan}>{sem.cgpa}</td>
                  <td rowSpan={sem.rowspan}>{sem.enrolled_credits}</td>
                  <td rowSpan={sem.rowspan}>{sem.earned_credits}</td>
                </>
              )}
            </tr>
          ))
        )}
        </tbody>
      </Table>
    </div>
  );
};

export default SemesterGrade;
